
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7Tq4R", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $a2725444c60d8295$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $k2OeR = parcelRequire("k2OeR");

var $j0nzO = parcelRequire("j0nzO");

var $14zFQ = parcelRequire("14zFQ");

var $dJ4mM = parcelRequire("dJ4mM");

var $6wlNh = parcelRequire("6wlNh");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-c4f526d3c1";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $a2725444c60d8295$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $k2OeR.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $k2OeR.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $EyEcw.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(/*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
                locale: locale,
                messages: window.SSR_languagePack,
                cookies: document.cookie,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJ4mM.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    pureClientMode: true,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    // @ts-ignore
                    compositionMetrics: window.compositionMetrics,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    clusterTag: window.clusterTag,
                    auxiaResponse: window.auxiaResponse,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    children: Component
                })
            }));
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), /*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $14zFQ.Layout), {
                analyticsWebClient: analyticsWebClient,
                location: window.location,
                pricing: window.prices,
                availableProducts: window.availableProducts,
                // @ts-ignore
                tutorial: window.tutorial,
                templates: window.templates,
                partnerTemplates: window.partnerTemplates,
                collections: window.collections,
                categories: window.categories,
                userProfile: window.userProfile,
                userProfileStatus: window.userProfileStatus,
                userContext: window.userContext,
                userContextStatus: window.userContextStatus,
                loggedOutContext: window.loggedOutContext,
                loggedOutContextStatus: window.loggedOutContextStatus,
                countryCode: window.countryCode,
                composition: window._uniformPreloadedComposition,
                // @ts-ignore
                compositionMetrics: window.compositionMetrics,
                isUniformPlayground: window.isUniformPlayground,
                isAllowPostMessage: window.isAllowPostMessage,
                teamType: window.teamType,
                keyword: window.keyword,
                mlTemplateIds: window.mlTemplateIds,
                referrer: window.referrer,
                anchor: window.anchor,
                subAnchor: window.subAnchor,
                clusterTag: window.clusterTag,
                auxiaResponse: window.auxiaResponse,
                transactionAccounts: window.transactionAccounts,
                userAgent: userAgent,
                children: Component
            })
        }), {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("f0Hih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("dhmEV")).default; });

var $dhmEV = parcelRequire("dhmEV");

});

parcelRegister("3XfGP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e130d715135cd6b$export$2e2bcd8739ae039; });

var $iB48s = parcelRequire("iB48s");

var $dQt1t = parcelRequire("dQt1t");

var $iSvIT = parcelRequire("iSvIT");

var $6IiXU = parcelRequire("6IiXU");

var $4WLmP = parcelRequire("4WLmP");
var $2e130d715135cd6b$var$_excluded = [
    "appearance",
    "isDisabled",
    "isSelected",
    "isLoading",
    "spacing"
];
/**
 * __Loading button__
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ var $2e130d715135cd6b$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function LoadingButton(_ref, ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, spacing = _ref.spacing, rest = (0, $dQt1t.default)(_ref, $2e130d715135cd6b$var$_excluded);
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6IiXU.default), (0, $iB48s.default)({}, rest, {
        ref: ref,
        appearance: appearance,
        "aria-busy": isLoading,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4WLmP.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
$2e130d715135cd6b$var$LoadingButton.displayName = "LoadingButton";
var $2e130d715135cd6b$export$2e2bcd8739ae039 = $2e130d715135cd6b$var$LoadingButton;

});
parcelRegister("4WLmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39a15251825d0efd$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $8HJYY = parcelRequire("8HJYY");
function $39a15251825d0efd$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $39a15251825d0efd$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $8HJYY.default), {
        size: size,
        appearance: $39a15251825d0efd$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("8HJYY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65660203519f4bc0$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $jkaxq = parcelRequire("jkaxq");

var $lG0aY = parcelRequire("lG0aY");

var $9c5Gg = parcelRequire("9c5Gg");

var $3lt1l = parcelRequire("3lt1l");
/**
 * Returns the appropriate circle stroke color.
 */ function $65660203519f4bc0$var$getStrokeColor(_ref) {
    var mode = _ref.mode, appearance = _ref.appearance;
    if (mode === "light") return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $lG0aY.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $lG0aY.N0), ")");
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $lG0aY.DN900), ")") : "var(--ds-icon-inverse, ".concat((0, $lG0aY.DN500), ")");
}
var $65660203519f4bc0$var$rotate = (0, $2ZUkg.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $65660203519f4bc0$var$rotateStyles = (0, $2ZUkg.css)({
    animation: "".concat($65660203519f4bc0$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $65660203519f4bc0$var$loadIn = (0, $2ZUkg.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $65660203519f4bc0$var$loadInStyles = (0, $2ZUkg.css)({
    animation: "".concat($65660203519f4bc0$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $65660203519f4bc0$var$wrapperStyles = (0, $2ZUkg.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $65660203519f4bc0$var$circleStyles = (0, $2ZUkg.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $65660203519f4bc0$var$useLayoutEffect = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);
var $65660203519f4bc0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Spinner(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "inherit" : _ref2$appearance, _ref2$delay = _ref2.delay, delay = _ref2$delay === void 0 ? 0 : _ref2$delay, interactionName = _ref2.interactionName, label = _ref2.label, _ref2$size = _ref2.size, providedSize = _ref2$size === void 0 ? "medium" : _ref2$size, testId = _ref2.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $3lt1l.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var _useGlobalTheme = (0, $9c5Gg.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var stroke = $65660203519f4bc0$var$getStrokeColor({
        mode: mode,
        appearance: appearance
    });
    var context = (0, $iSvIT.useContext)((0, $jkaxq.default));
    $65660203519f4bc0$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $2ZUkg.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $65660203519f4bc0$var$wrapperStyles,
            $65660203519f4bc0$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $2ZUkg.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label,
        css: $65660203519f4bc0$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        }
    }, (0, $2ZUkg.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $65660203519f4bc0$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));

});
parcelRegister("3lt1l", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $26f9d8295bdc29c4$export$4e9f1640bbe7a1a8; });
var $26f9d8295bdc29c4$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("53DZ3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3aec3f7c0e69d664$var$_react = $3aec3f7c0e69d664$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $3aec3f7c0e69d664$var$_statusWarning = $3aec3f7c0e69d664$var$_interopRequireDefault((parcelRequire("goemm")));
function $3aec3f7c0e69d664$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3aec3f7c0e69d664$var$WarningIcon = (props)=>/*#__PURE__*/ $3aec3f7c0e69d664$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $3aec3f7c0e69d664$var$_statusWarning.default
    }));
$3aec3f7c0e69d664$var$WarningIcon.displayName = "WarningIcon";
var $3aec3f7c0e69d664$var$_default = module.exports.default = $3aec3f7c0e69d664$var$WarningIcon;

});
parcelRegister("goemm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::435e803a057e79e21a0d31c5b12f3f81>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $beea06c80568ff37$var$_react = $beea06c80568ff37$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $beea06c80568ff37$var$_baseNew = $beea06c80568ff37$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $beea06c80568ff37$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $beea06c80568ff37$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $beea06c80568ff37$var$_react.default.createElement($beea06c80568ff37$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$beea06c80568ff37$var$StatusWarningIcon.displayName = "StatusWarningIcon";
var $beea06c80568ff37$var$_default = module.exports.default = $beea06c80568ff37$var$StatusWarningIcon;

});


parcelRegister("9jWQb", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", function () { return $6c9387eaef4d4c57$export$30ab340faaed55d4; });

var $iSvIT = parcelRequire("iSvIT");
var $6c9387eaef4d4c57$var$useConstructor = function useConstructor(callback) {
    var hasBeenFired = (0, $iSvIT.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
var $6c9387eaef4d4c57$export$30ab340faaed55d4 = function useUFOComponentExperience(experience) {
    (0, $iSvIT.useEffect)(function() {
        return function() {
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $6c9387eaef4d4c57$var$useConstructor(function() {
        return experience.start();
    });
    return null;
};

});

parcelRegister("ctYD4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9167392384132023$var$_react = $9167392384132023$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9167392384132023$var$_baseNew = $9167392384132023$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $9167392384132023$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9167392384132023$var$CommentIcon = (props)=>/*#__PURE__*/ $9167392384132023$var$_react.default.createElement($9167392384132023$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$9167392384132023$var$CommentIcon.displayName = "CommentIcon";
var $9167392384132023$var$_default = module.exports.default = $9167392384132023$var$CommentIcon;

});

parcelRegister("30lzE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23021b54e58d1b56$var$_react = $23021b54e58d1b56$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $23021b54e58d1b56$var$_baseNew = $23021b54e58d1b56$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $23021b54e58d1b56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23021b54e58d1b56$var$RoadmapIcon = (props)=>/*#__PURE__*/ $23021b54e58d1b56$var$_react.default.createElement($23021b54e58d1b56$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$23021b54e58d1b56$var$RoadmapIcon.displayName = "RoadmapIcon";
var $23021b54e58d1b56$var$_default = module.exports.default = $23021b54e58d1b56$var$RoadmapIcon;

});

parcelRegister("cm6I6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fecbea8f909d674$var$_react = $8fecbea8f909d674$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $8fecbea8f909d674$var$_baseNew = $8fecbea8f909d674$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $8fecbea8f909d674$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8fecbea8f909d674$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $8fecbea8f909d674$var$_react.default.createElement($8fecbea8f909d674$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$8fecbea8f909d674$var$EyeOpenIcon.displayName = "EyeOpenIcon";
var $8fecbea8f909d674$var$_default = module.exports.default = $8fecbea8f909d674$var$EyeOpenIcon;

});

parcelRegister("3uD1D", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28b2720e9e231e40$var$_react = $28b2720e9e231e40$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $28b2720e9e231e40$var$_baseNew = $28b2720e9e231e40$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $28b2720e9e231e40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28b2720e9e231e40$var$LockLockedIcon = (props)=>/*#__PURE__*/ $28b2720e9e231e40$var$_react.default.createElement($28b2720e9e231e40$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$28b2720e9e231e40$var$LockLockedIcon.displayName = "LockLockedIcon";
var $28b2720e9e231e40$var$_default = module.exports.default = $28b2720e9e231e40$var$LockLockedIcon;

});

parcelRegister("iHmgk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aedef9bb726854d64999097926d2fc86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9cd82fde84d01f4$var$_react = $d9cd82fde84d01f4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $d9cd82fde84d01f4$var$_baseNew = $d9cd82fde84d01f4$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $d9cd82fde84d01f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d9cd82fde84d01f4$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $d9cd82fde84d01f4$var$_react.default.createElement($d9cd82fde84d01f4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$d9cd82fde84d01f4$var$PersonAvatarIcon.displayName = "PersonAvatarIcon";
var $d9cd82fde84d01f4$var$_default = module.exports.default = $d9cd82fde84d01f4$var$PersonAvatarIcon;

});

parcelRegister("guk0p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7c2be3f7c9d9cc79e629bb0768f3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c00ef75bf5693ff4$var$_react = $c00ef75bf5693ff4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $c00ef75bf5693ff4$var$_baseNew = $c00ef75bf5693ff4$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $c00ef75bf5693ff4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Timeline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for timelines in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c00ef75bf5693ff4$var$TimelineIcon = (props)=>/*#__PURE__*/ $c00ef75bf5693ff4$var$_react.default.createElement($c00ef75bf5693ff4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11 2.5H1V1h10zm4 4.167H5v-1.5h10zm-4 4.167H1v-1.5h10zM15 15H5v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$c00ef75bf5693ff4$var$TimelineIcon.displayName = "TimelineIcon";
var $c00ef75bf5693ff4$var$_default = module.exports.default = $c00ef75bf5693ff4$var$TimelineIcon;

});


var $7Tq4R = parcelRequire("7Tq4R");

var $b45Um = parcelRequire("b45Um");
(0, $7Tq4R.init)((0, $b45Um.SignupPage));


//# sourceMappingURL=signup-page.64c65054.js.map
